import { ChainId } from '@xterswap/sdk-core'

export const MULTICALL2_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.XTERIO_TESTNET]: '0xE9e99e7865780aC94194533cFEc1Bf04592Ad5CC',
  [ChainId.XTERIO]: '0xB0B8c92a12655E97A692cb6Dc1867abc71BeFDBC',
  [ChainId.BNB]: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
}

// not support v2 router, only v3 trade supported
export const V2_ROUTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.XTERIO_TESTNET]: '',
  [ChainId.XTERIO]: '',
  [ChainId.BNB]: '0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24',
}

export const V3_CORE_FACTORY_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.XTERIO_TESTNET]: '0x83957422e417ce43c493199ef6c1162c12fd8a37',
  [ChainId.XTERIO]: '0x8236a1122e622CD9C3B0df339159910a414aaF47',
  [ChainId.BNB]: '0xdB1d10011AD0Ff90774D0C6Bb92e5C5c8b4461F7',
}
export const QUOTER_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.XTERIO_TESTNET]: '0x4216bcc3d4b52226c654ad252fb99416e4f3ac6a',
  [ChainId.XTERIO]: '0x73f8576fd0a02B6bbe73916987Bb10E94C8eEEB8',
  [ChainId.BNB]: '0x78D78E420Da98ad378D7799bE8f4AF69033EB077',
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.XTERIO_TESTNET]: '0x6f58796d4563a5140cb636fd4c48eb20fe97ff1f',
  [ChainId.XTERIO]: '0x6D56AB28E6245E686552c75432498F79932f83ac',
  [ChainId.BNB]: '0x7b8A01B39D58278b5DE7e48c8449c9f4F5170613',
}
export const ENS_REGISTRAR_ADDRESSES = {}
export const SWAP_ROUTER_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.XTERIO_TESTNET]: '0x61aac87e5ab099d236082a949fc22ffa02bc08be',
  [ChainId.XTERIO]: '0x97E4C632674D5E952E64FB40033EA1Be25f62c70',
  [ChainId.BNB]: '0xbc8Bc9ebE4f0381333248F5c4994D17C128Ce5e7',
}
export const V3_MIGRATOR_ADDRESSES = {}
